import script from "./WeightPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./WeightPanel.vue?vue&type=script&setup=true&lang=js"

import "./WeightPanel.vue?vue&type=style&index=0&id=008b0f5f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-008b0f5f"]])

export default __exports__